import { type App } from "vue";
import { Quasar, Notify } from "quasar";
import "@quasar/extras/material-icons/material-icons.css";
import "quasar/src/css/index.sass";

export default function (app: App) {
  app.use(Quasar, {
    plugins: {
      Notify,
    },
  });
}
